import { getConfigPageService } from '../services/page';
import { request } from './index';
import ErrorModel from './errorModel';

export const getConfigPage = ({ slug, type = 'tplA' }) => new Promise((resolve, reject) => {
  request(
    `getConfigPage/${type}/${slug}`,
    getConfigPageService.bind(this, { slug }),
  ).then(({ item }) => {
    resolve(item);
  }).catch((e) => {
    reject(new ErrorModel(e));
  });
});
